module.exports = __webpack_public_path__ + "files/9d800f806844d49e94036f2cf205fce8.svg";